import { render, staticRenderFns } from "./SamfapEye.vue?vue&type=template&id=31b6e7d4&scoped=true&"
import script from "./SamfapEye.vue?vue&type=script&lang=js&"
export * from "./SamfapEye.vue?vue&type=script&lang=js&"
import style0 from "./SamfapEye.vue?vue&type=style&index=0&id=31b6e7d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6e7d4",
  null
  
)

export default component.exports